// src/hooks/useCrudData.js
import { useState, useEffect } from "react";
import axios from "axios";
import useAxiosConfig from "../../../../config/useAxiosConfig";

const useData = () => {
  const { loading: axiosLoading, error, postData: apiPost } = useAxiosConfig();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await axios.get("/DistrictSchools");
        setData(response.data?.rows || []);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false);
      }
    };

    if (!axiosLoading) {
      fetchData();
    }
  }, [axiosLoading]);

  const postData = async (newData) => {
    try {
      const { district, school_name, school_id } = newData; // Destructure newData object
      const postData = {
        jsStruct: JSON.stringify({
          district,
          school_name,
          school_id,
        }),
      };
      const response = await axios.post("/DistrictSchools", postData);
      return response.data;
    } catch (error) {
      console.error("Error adding data:", error);
      throw error;
    }
  };

  const updateData = async (updatedData) => {
    try {
      const { id, district, school_name, school_id } = updatedData;
      const putData = {
        jsStruct: JSON.stringify({
          id,
          district,
          school_name,
          school_id,
        }),
      };
      const response = await axios.put(`/DistrictSchools/${id}`, putData);
      setData((prevData) =>
        prevData.map((item) =>
          item.id === id ? { ...item, ...updatedData } : item
        )
      );
      return response.data;
    } catch (error) {
      console.error("Error updating data:", error);
      throw error;
    }
  };

  const deleteData = async (dId) => {
    try {
      await axios.delete(`/DistrictSchools/${dId}`);
      setData(data.filter((d) => d.id !== dId));
    } catch (error) {
      console.error("Error deleting Item:", error);
      throw error;
    }
  };

  return { data, loading, error, postData, updateData, deleteData };
};

export default useData;
